import Component from './Component';
import Bouncer from 'formbouncerjs/dist/bouncer.min';
 
export default class FormComponent extends Component {
    get SELECTORS() {
        return {
            loginForm: '[id^="login-form"]',
            loginButton: '.js-login-button',
            username: 'input[name="j_username"]',
            password: 'input[name="j_password"]',
            iconPwd: '.icon-pwd'
        }
    }
 
    get CLASSES() {
        return {
            showPwd: 'iconshow-pwd',
            hidePwd: 'iconhide-pwd'
        }
    }
 
    get ARIA_LABELS() {
        return {
            showPwd: 'Visualizza Password',
            hidePwd: 'Nascondi Password'
        }
    }
   
    constructor() {
        super();
        this.formValidator = null;
    }
 
    configFormValidation() {
        this.formValidator = new Bouncer('form', {
            messageAfterField: false,
            fieldClass: 'error-field',
            errorClass: 'error-message',
            messageCustom: 'data-bouncer-message',
            messageTarget: 'data-bouncer-target',
 
            messages: {
                missingValue: {
                    checkbox: 'Campo obbligatorio',
                    radio: 'Seleziona un valore',
                    select: 'Seleziona un valore',
                    'select-multiple': 'Seleziona almeno un valore',
                    default: 'Campo obbligatorio'
                },
                patternMismatch: {
                    email: 'Inserisci un indirizzo email valido',
                    url: 'Inserisci un URL corretto',
                    number: 'Campo numerico',
                    date: 'Inserisci il formato della data corretto DD-MM-YYYY',
                    // time: 'Please use the 24-hour time format. Ex. 23:00',
                    // month: 'Please use the YYYY-MM format',
                    default: 'Inserisci il formato corretto'
                },
                outOfRange: {
                    over: 'Il valore inserito non deve essere maggiore di {max}',
                    under: 'Il valore inserito non deve essere minore di {min}'
                },
                wrongLength: {
                    over: 'Il valore inserito non può avere più di {maxLength} caratteri. Ne stai usando {length}',
                    under: 'Il valore inserito non può avere meno di {minLength} caratteri. Ne stai usando {length}'
                }
            },      
        });
    }
 
    showPwd(element){
        const inputPwd = element.parentNode.querySelector('input');
 
        element.classList.toggle(this.CLASSES.hidePwd);
        element.classList.toggle(this.CLASSES.showPwd);
 
        if (inputPwd.type === 'password') {
            inputPwd.type = 'text';
            element.firstElementChild.setAttribute('href','#iconshow-pwd');
            element.firstElementChild.setAttribute('aria-label', this.ARIA_LABELS.hidePwd);
        } else {
            inputPwd.type = 'password';
            element.firstElementChild.setAttribute('href','#iconhide-pwd');
            element.firstElementChild.setAttribute('aria-label', this.ARIA_LABELS.showPwd);
        }
    }
 
    resetForm(formId){
        const form = document.getElementById(formId);
        form.reset();
        for(const input of form.querySelectorAll("input[type=hidden]")){
            input.value = '';
        }
    }
 
    createInputError(input, message) {
        let error = document.createElement("div");
        error.classList.add('error-message');
        error.setAttribute('id','bouncer-error_name');
        error.innerHTML = message;
        if(!!input.parentNode.querySelector('.error-message')) {
            input.parentNode.querySelector('.error-message').remove();
        }
        input.parentNode.insertBefore(error, input);
        input.classList.add('error-field');
    }
 
    disableLoginButton(form){
        let username = form.querySelector(this.SELECTORS.username),
            password = form.querySelector(this.SELECTORS.password);
 
        if (!!username.value && !!password.value && !username.classList.contains('error-field') && !password.classList.contains('error-field')) {
            form.querySelector(this.SELECTORS.loginButton).setAttribute('disabled','')
        }
    }
 
    bindEvents() {
        const iconsPwd = document.querySelectorAll(this.SELECTORS.iconPwd);
 
        for(const iconPwd of iconsPwd) {
            iconPwd.addEventListener('click', (e)=>{
                this.showPwd(iconPwd);
            });
        }
 
        this.events.on('keydown', "input[type='number']", (e) => {
            if (e.which === 38 || e.which === 40) {
                e.preventDefault();
            }
        });
 
        this.events.on('wheel', 'input[type=number]', (e) => e.target.blur());
 
        document.querySelectorAll(this.SELECTORS.loginForm).forEach(form => {
            form.addEventListener('submit', (e) => {
                const loginForm = e.target.matches(this.SELECTORS.loginForm) ? e.target : e.target.closest(this.SELECTORS.loginForm);
                this.disableLoginButton(loginForm)})
        });
    }
 
    render() {
        this.log('render Form');
        this.configFormValidation();
        this.bindEvents();
    }
}
 